import React from 'react';
import { AppComponent } from 'utils/components';

export default function Text(props: { component: AppComponent }) {
	const variables = JSON.parse(props.component.variables);

	return <h1>{variables.txt}</h1>;
}
